import { faCirclePause, faCirclePlay } from "@fortawesome/free-regular-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { wrapURL } from "../Utils/DownloadUtils"

const resolveOnbase = (ob) => {
  switch (ob) {
    case 0:
      return ['', '', '']
    case 1:
      return [' diamond_highlight', '', '']
    case 2:
      return ['', ' diamond_highlight', '']
    case 3:
      return [' diamond_highlight', ' diamond_highlight', '']
    case 4:
      return ['', '', ' diamond_highlight']
    case 5:
      return [' diamond_highlight', '', ' diamond_highlight']
    case 6:
      return ['', ' diamond_highlight', ' diamond_highlight']
    case 7:
      return [' diamond_highlight', ' diamond_highlight', ' diamond_highlight']
    default:
      return ['', '', '']
  }
}

export const VideoOptionSnippet = ({mode, title, playing, index, camindex, checked, setSelectedCam, setAvailable, setURL, setDownload, data, cams}) => {
  const pid = mode === 'balls'? `${data.plate_id}_${data.Pitch_ID}`:`${data.plate_id}`
  const handleOnCheck = (e) => {
    const inn = data.Inning+"局"+(data["Top/Bottom"]==="Top"? "上":"下")
    const result = data.PA_Result? data.PA_Result:data.PitchCode
    const id = mode === 'balls'? `[${data.plate_id}${data.Pitch_ID}]`:`[${data.plate_id}]`
    let initarr = [...checked]
    if (e.target.checked) {
      if (mode === 'balls') initarr[index] = {id: pid, cam: camindex, name: `${id}_${title}_${data.Date}_G${data.GameNo}_${inn}_${data.Pitcher}_${data.Batter}_${data.TaggedPitchType}_${result}`}
      else initarr[index] = {id: pid, name: `${id}_${data.Date}_G${data.GameNo}_${inn}_${data.Pitcher}_${data.Batter}_${result}`}
    } else {
      initarr[index] = false
    }
    setDownload(initarr)
  }
  return (
    <div className="video-option-tag" onClick={(e) => {setURL(wrapURL(mode, {id: pid, cam: camindex}, cams));setAvailable(true);setSelectedCam(camindex)}}>
      <div><input checked={checked[index]} onChange={(e) => handleOnCheck(e)} type="checkbox" /></div>
      <div className={"video-option-tag-but"+(playing? " playing":"")}>
        <div><FontAwesomeIcon icon={faCirclePlay} /></div>
        <div>{title}</div>
      </div>
    </div>
  )
}

export const VideoEntryRow = ({data, setAvailable, setURL, selectedEntry, setSelectedEntry, checked, index, setDownload, cams, selectedCam, setSelectedCam, setIndex}) => {
  const obstr = resolveOnbase(data['On-Base'])
  const isInvalidValue = (s) => (s&&s[0]===undefined)
  const pid = `${data.plate_id}_${data.Pitch_ID}`
  
  return (
    <div>
      <div className="media_eachball" id={pid} onClick={(e) => {setURL(`https://stats-inisght.synology.me/gamevideo/balls/${pid}.mp4`);setAvailable(true);setSelectedEntry(pid);setSelectedCam(0);setIndex(index);}}>
        <div className="clear"/>
        <div className="media_eachball_form_frame">
          <table className="media_eachball_form" style={selectedEntry===pid?{border: "solid 3px #005EB5"}:{}}>
            <tr>
              {/* <td><input checked={checked[index]} onChange={(e) => handleOnCheck(e)} type="checkbox" /></td> */}
              <td className="date"><span>日期</span>{data.Date}</td>
              <td><span>賽事編號</span>{data.GameNo}</td>
              <td>{data.Inning? (" "+data.Inning+"局"+(data["Top/Bottom"]==="Top"? "上":"下")):""}</td>
              <td>
                <div className="media_eachball_block">
                  {[1,2,3].map((e) => (<div className={`media_eachball_diamond${e}`+obstr[e-1]} />))}
                </div>
              </td>
              <td>
                <div className="media_eachball_block">
                  {[1,2,3].map((e) => (<div className={`media_eachball_ball${e}`+(e<=data.Balls? ' ball_highlight':'')} />))}
                  {[1,2].map((e) => (<div className={`media_eachball_strike${e}`+(e<=data.Strikes? ' strike_highlight':'')} />))}
                  {[1,2].map((e) => (<div className={`media_eachball_out${e}`+(e<=data.Outs? ' out_highlight':'')} />))}
                </div>
              </td>
              <td className="name">
                <span>投手</span>
                {data.Pitcher}
              </td>
              <td className="name">
                <span>打者</span>
                {data.Batter}
              </td>
              <td>
                <span>結果</span>
                {data.PA_Result? data.PA_Result:data.PitchCode}
              </td>
              <td>
                <span>球速</span>
                {isInvalidValue(data.VeloRel)? data.VeloRel:data.APP_VeloRel}km
              </td>
              <td>
                <span>球種</span>
                {data.TaggedPitchType}
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  )
}

const VideoPlateEntryBallRow = ({data}) => {
  const obstr = resolveOnbase(data['On-Base'])
  const isInvalidValue = (s) => (s&&s[0]===undefined)
  const pid = `${data.plate_id}_${data.Pitch_ID}`
  
  return (
    <div className="media_eachball">
      <div className="clear"/>
      <div className="media_eachball_form_frame">
        <table className="media_eachball_form">
          <tr>
            <td>{data.Inning? (" "+data.Inning+"局"+(data["Top/Bottom"]==="Top"? "上":"下")):""}</td>
            <td>
              <div className="media_eachball_block">
                {[1,2,3].map((e) => (<div className={`media_eachball_diamond${e}`+obstr[e-1]} />))}
              </div>
            </td>
            <td>
              <div className="media_eachball_block">
                {[1,2,3].map((e) => (<div className={`media_eachball_ball${e}`+(e<=data.Balls? ' ball_highlight':'')} />))}
                {[1,2].map((e) => (<div className={`media_eachball_strike${e}`+(e<=data.Strikes? ' strike_highlight':'')} />))}
                {[1,2].map((e) => (<div className={`media_eachball_out${e}`+(e<=data.Outs? ' out_highlight':'')} />))}
              </div>
            </td>
            <td className="name">
              <span>投手</span>
              {data.Pitcher}
            </td>
            <td className="name">
              <span>打者</span>
              {data.Batter}
            </td>
            <td>
              <span>結果</span>
              {data.PA_Result? data.PA_Result:data.PitchCode}
            </td>
            <td>
              <span>球速</span>
              {isInvalidValue(data.VeloRel)? data.VeloRel:data.APP_VeloRel}km
            </td>
            <td>
              <span>球種</span>
              {data.TaggedPitchType}
            </td>
          </tr>
        </table>
      </div>
    </div>
  )
}

export const VideoPlateEntryRow = ({data, setAvailable, setURL, selectedEntry, setSelectedEntry, checked, index, setDownload, setIndex}) => {
  const obstr = resolveOnbase(data['On-Base'])
  const isInvalidValue = (s) => (s&&s[0]===undefined)
  const pid = `${data.plate_id}`

  const handleOnCheck = (e) => {
    const inn = data.Inning+"局"+(data["Top/Bottom"]==="Top"? "上":"下")
    const result = data.PA_Result
    const id = `[${data.plate_id}]`
    let initarr = [...checked]
    if (e.target.checked) {
      initarr[index] = {id: pid, name: `${id}_${data.Date}_G${data.GameNo}_${inn}_${data.Pitcher}_${data.Batter}_${result}`}
    } else {
      initarr[index] = false
    }
    setDownload(initarr)
  }
  
  return (
    <div className="media_eachball" id={pid} onClick={(e) => {setURL(`https://stats-inisght.synology.me/gamevideo/plates/${pid}.mp4`);setAvailable(true);setSelectedEntry(pid);setIndex(index);}}>
      <div className="clear"/>
      <div className="media_eachball_form_frame">
        <table className="media_eachball_form" style={selectedEntry===pid?{border: "solid 3px #005EB5"}:{}}>
          <tr>
            {/* <td><input checked={checked[index]} onChange={(e) => handleOnCheck(e)} type="checkbox" /></td> */}
            <td><span>日期</span>{data.Date}</td>
            <td><span>賽事編號</span>{data.GameNo}</td>
            <td>{data.Inning? (" "+data.Inning+"局"+(data["Top/Bottom"]==="Top"? "上":"下")):""}</td>
            <td>
              <div className="media_eachball_block">
                {[1,2,3].map((e) => (<div className={`media_eachball_diamond${e}`+obstr[e-1]} />))}
              </div>
            </td>
            <td>
              <div className="media_eachball_block">
                {[1,2,3].map((e) => (<div className={`media_eachball_ball${e}`+(e<=data.Balls? ' ball_highlight':'')} />))}
                {[1,2].map((e) => (<div className={`media_eachball_strike${e}`+(e<=data.Strikes? ' strike_highlight':'')} />))}
                {[1,2].map((e) => (<div className={`media_eachball_out${e}`+(e<=data.Outs? ' out_highlight':'')} />))}
              </div>
            </td>
            <td className="name">
              <span>投手</span>
              {data.Pitcher}
            </td>
            <td className="name">
              <span>打者</span>
              {data.Batter}
            </td>
            <td>
              <span>結果</span>
              {data.PA_Result? data.PA_Result:data.PitchCode}
            </td>
          </tr>
        </table>
        {selectedEntry === pid ? <div className="plate_each_ball"> {data.ball_data.map((e) => <VideoPlateEntryBallRow data={e} />)}</div> : []}
      </div>

    </div>
  )
}